// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CompanySettingsController = function ($rootScope, $scope, AccountSettings) {
    $scope.accountSettings = AccountSettings.get();
    $scope.save = function () {
        if (!$rootScope.isValid($scope.form))
            return;        
        
        $scope.accountSettings.$update({}, function () {
            $scope.notifySuccess();
        });        
    };
    
    $scope.dataValid = function () {
        return !$scope.form.creditorIdentifier.$invalid &&
            !$scope.form.vatId.$invalid &&
            !$scope.form.nationalCompanyId.$invalid &&
            !$scope.form.iban.$invalid &&
            !$scope.form.bic.$invalid &&
            !$scope.form.qriban.$invalid &&
            !$scope.form.website.$invalid;
    };

};
CompanySettingsController.$inject = ['$rootScope', '$scope', 'AccountSettings'];
